var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:[_vm.symbol.id],attrs:{"viewBox":_vm.symbol.viewBox,"width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":_vm.symbol.url ? _vm.symbol.url : '#' + _vm.symbol.id}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657c087a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SvgIcon.vue
// module id = tC0t
// module chunks = 0